import React from "react";
import get from "lodash/get";
import { object, shape } from "prop-types";
import { LazyCollection, LazyLoadImages, replaceAllStoriesInCollection, WithPreview } from "@quintype/components";
import { DfpComponent } from "../ads/dfp-component";

import { getCollectionTemplate } from "../get-collection-template";
//import { NewsSummariesButton } from "../atoms/NewsSummariesButton";
// import { GoAdFreeWidgetBlack } from "../molecules";
// import GoAdFreeWidgetRed from "../molecules/GoAdFreeWidgetRed";
import { BrowserView, MobileView } from "react-device-detect";
import { useDeviceType } from "../customHooks/useDeviceType";
//import get from "lodash/get";
//import { useSelector } from "react-redux";

export const HomePage = (props) => {
  const networkId = get(props.config, ["ads-config", "network_id"], {});
  const homeGutterAdStatus = get(props.config, ["publisher-attributes", "home_gutter_ad_status"], false);
  const isMobile = useDeviceType() !== "desktop";

  //const qtState = get(useSelector((state) => state),["qt"],{});
  //const isWebView = get(qtState, ["config", "isWebView"]) === true;

  return (
    <div className="container">
      {homeGutterAdStatus && (
        <div class="gutter-ad-main">
          <div class="gutter-ad-container left">
            <div class="gutter-ad">
              {!isMobile && (
                <BrowserView>
                  <DfpComponent
                    id={`richmedia-div-gutter-ad-lhs`}
                    adSlotConfigName="120x600_left_ad"
                    showText={false}
                    adStyleName="ad-style-rich-media"
                  />
                </BrowserView>
              )}
            </div>
          </div>
          <div class="gutter-ad-container right">
            <div class="gutter-ad">
              {!isMobile && (
                <BrowserView>
                  <DfpComponent
                    id={`richmedia-div-gutter-ad-rhs`}
                    adSlotConfigName="120x600_right_ad"
                    showText={false}
                    adStyleName="ad-style-rich-media"
                  />
                </BrowserView>
              )}
            </div>
          </div>
        </div>
      )}
      <h1 style={{ display: "none" }}>Fortune India - Top Stories</h1>
      {/*!isWebView && <NewsSummariesButton />*/}

      {homeGutterAdStatus && !isMobile && (
        <BrowserView>
          <DfpComponent
            id={`home-richmddia-ad-1`}
            adSlotConfigName="1024x75_ad"
            showText={false}
            adStyleName="ad-style-rich-media"
          />
        </BrowserView>
      )}
      <LazyLoadImages>
        <LazyCollection
          collection={props.data.collection}
          collectionTemplates={getCollectionTemplate}
          lazyAfter={6}
          {...props}
        />
      </LazyLoadImages>
      {/* <GoAdFreeWidgetRed />
      <GoAdFreeWidgetBlack /> */}
    </div>
  );
};

HomePage.propTypes = {
  data: shape({
    collection: object,
  }),
};

export const HomePagePreview = WithPreview(HomePage, (data, story) =>
  Object.assign({}, data, {
    collection: replaceAllStoriesInCollection(data.collection, story),
  })
);
